import { createApp } from 'vue'
import { vuetify } from '../vuetify'
import { i18n } from '../i18n'
import { createPinia } from 'pinia'
import VHomepageArticles from '../components/VHomepageArticles.vue'
import VReferenceSlider from '../components/VReferenceSlider.vue'
import { app } from '../app'

const pinia = createPinia()

createApp({
  components: {
    VHomepageArticles,
    VReferenceSlider
  },
  extends: app
})
  .use(vuetify)
  .use(i18n)
  .use(pinia)
  .mount('#app')
